import DocsSidebarNav from "./DocsSidebarNav";
import sidebarStyles from "../../styles/docs/docsSidebar.module.scss";

const DocsSidebarDesktop = ({ docNav, activeId, onNavigate }) => (
  <aside className={sidebarStyles.sidebarDesktop}>
    <DocsSidebarNav
      docNav={docNav}
      activeId={activeId}
      onNavigate={onNavigate}
      variant="desktop"
    />
  </aside>
);

export default DocsSidebarDesktop;
